import { object } from 'yup';
export function createExactSchema() {
    return (shape) => {
        return object(shape);
    };
}
